import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import * as router from 'react-router-dom';
import {Container} from 'reactstrap';
import './Style.scss'
import {
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav, AppSidebarMinimizer,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_hr_nav';
// routes config
import routes from '../../routes';
import './Style.scss'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import Cookies from "js-cookie";

import DefaultHeader from "./HRHeader";
import DefaultFooter from "../DefaultLayout/DefaultFooter";
import * as keys from "../../const/key/Key";


class HRLayout extends Component {

  loading = () => <span/>;

  signOut(e) {
    e.preventDefault();
    Cookies.remove(keys.ACCESS_TOKEN);
    Cookies.remove(keys.REFRESH_TOKEN);
    this.props.history.push('/login')
  }

  componentWillMount(){ document.title = "VisitorTags"; }

  render() {
    return (
      <div className="app hr-layout">
        <AppHeader fixed>
          <DefaultHeader onLogout={e => this.signOut(e)}/>
        </AppHeader>

        <div className="app-body">
          <AppSidebar className="navBarWidth" fixed display="lg">
            <AppSidebarHeader/>
            <AppSidebarForm/>

            <AppSidebarNav className="navBarWidth" navConfig={navigation} {...this.props} router={router}/>

            <AppSidebarFooter/>
            <AppSidebarMinimizer/>
          </AppSidebar>
          <main className="main margin-left239">
            <AppBreadcrumb appRoutes={routes} router={router}/>
            <Container fluid>

              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component {...props} />
                      )}/>
                  ) : (null);
                })}
              </Switch>

            </Container>
          </main>

        </div>

        <AppFooter>
          <DefaultFooter/>
        </AppFooter>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  system_changer: state.systemChangeReducer.system_changer
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard details handler
    addTagsDashboard: (data) => dispatch(actionCreator.addTagsDashboard(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HRLayout);
